import React from 'react';
import { Star } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';

const testimonials = [
  { name: 'John Smith', text: 'Excellent service! The driver was very professional and always on time. Highly recommended!', avatar: 'https://randomuser.me/api/portraits/men/1.jpg' },
  { name: 'Maria Garcia', text: 'The best transportation company in Punta Cana. Clean vehicles and great prices.', avatar: 'https://randomuser.me/api/portraits/women/2.jpg' },
  { name: 'David Wilson', text: 'Comfortable vehicles and easy booking process. Will definitely use again!', avatar: 'https://randomuser.me/api/portraits/men/3.jpg' },
  { name: 'Felix Jerez', text: 'TTS Santos es una empresa que destaca por su compromiso, calidad y excelente atención. Siempre ofrece experiencias confiables que marcan la diferencia.', avatar: 'https://randomuser.me/api/portraits/men/12.jpg' },
];

const TestimonialsSection = () => {
  const { t } = useLanguage();
  return (
    <section className="py-24 bg-gradient-to-b from-[#0f0f0f] to-[#0a0a0a]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <span className="text-[#ff6b1a] text-sm font-bold tracking-[0.2em] uppercase">{t.testimonials.tag}</span>
          <h2 className="text-4xl md:text-5xl font-black text-white mt-3 mb-4">{t.testimonials.title}</h2>
          <p className="text-white/60 max-w-3xl mx-auto text-lg">{t.testimonials.subtitle}</p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {testimonials.map((tm, i) => (
            <div key={i} className="glass-card rounded-xl p-6 card-hover">
              <div className="flex gap-1 mb-3">
                {[1,2,3,4,5].map(s => <Star key={s} className="w-4 h-4 fill-[#ff6b1a] text-[#ff6b1a]" />)}
              </div>
              <p className="text-white/75 text-sm leading-relaxed mb-5 italic">“{tm.text}”</p>
              <div className="flex items-center gap-3 pt-4 border-t border-white/5">
                <img src={tm.avatar} alt={tm.name} className="w-11 h-11 rounded-full object-cover" />
                <div>
                  <div className="text-white font-semibold text-sm">{tm.name}</div>
                  <div className="text-white/50 text-xs">{t.testimonials.verified}</div>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="grid grid-cols-3 gap-6 mt-16 max-w-4xl mx-auto">
          <div className="text-center">
            <div className="text-4xl md:text-5xl font-black text-[#ff6b1a]">5.0</div>
            <div className="text-white/60 text-sm mt-1">{t.testimonials.stat1}</div>
          </div>
          <div className="text-center">
            <div className="text-4xl md:text-5xl font-black text-[#ff6b1a]">500+</div>
            <div className="text-white/60 text-sm mt-1">{t.testimonials.stat2}</div>
          </div>
          <div className="text-center">
            <div className="text-4xl md:text-5xl font-black text-[#ff6b1a]">1000+</div>
            <div className="text-white/60 text-sm mt-1">{t.testimonials.stat3}</div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;
